import { Flex, IconButton, Text } from '@chakra-ui/react';
import React, { useContext } from 'react';

import { DatePickerReactContext } from '@components/common/date/context';
import { MONTHS } from 'helpers/dates';

const DatePickerPager: React.FC = () => {
  const { pagedMonth, pagedYear, pageBy, decrement, increment } =
    useContext(DatePickerReactContext);
  return (
    <Flex justifyContent="space-between" alignItems="center" w="full">
      <Text
        data-testid="paged-by-text"
        fontWeight="semibold"
        lineHeight="1.125rem"
        fontSize="xs"
        py={1}
      >
        {pageBy === 'month' && `${MONTHS[pagedMonth]} `}
        {pagedYear}
      </Text>
      <Flex columnGap={2}>
        <IconButton
          data-testid="decrement-button"
          onClick={decrement}
          py="px"
          size="xs"
          color="gray.500"
          fontFamily="body"
          variant="subtle"
          bg="surface.muted"
          _hover={{ bg: 'surface.accent' }}
        >
          {'<-'}
        </IconButton>
        <IconButton
          data-testid="increment-button"
          onClick={increment}
          py="px"
          size="xs"
          color="gray.500"
          fontFamily="body"
          variant="subtle"
          bg="surface.muted"
          _hover={{ bg: 'surface.accent' }}
        >
          {'->'}
        </IconButton>
      </Flex>
    </Flex>
  );
};

export default React.memo(DatePickerPager);
